import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import BuyTextInput from './BuyTextInput'

class BuyCustomCalc extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const rata_mesile_label = 'Rata mensile desiderata'
    const quota_massima_finanziabile_formatted = numeral(this.props.max).format(
      '$ 0,0'
    )
    const quota_minima_finanziabile_formatted = numeral(this.props.min).format(
      '$ 0,0'
    )

    return (
      <div
        className="calculator-container"
        id="show-calculator"
        style={{
          display: 'block',
        }}
      >
        <div className="calculator-container-left">
          <ul className="data-form x-small" id="calcolatrice">
            <li className={this.props.selectQuotaDaFinanziareClassName}>
              <BuyTextInput
                classes={'form-input big'}
                isSymbol={'input-symbol'}
                label={'Quota da finanziare'}
                labelStyle={{ fontSize: '0.9rem' }}
                placeholder={'Scrivi la Quota da finanziare'}
                theSymbol={'€'}
                type={'text'}
                update={this.props.selectOnChange}
              />
              <div className="guide-tips">
                <span className="guide-tips-label">
                  Puoi finanziare da {quota_minima_finanziabile_formatted} a{' '}
                  {quota_massima_finanziabile_formatted}
                </span>
              </div>
            </li>

            <li className={this.props.liRataMensileClassName}>
              <BuyTextInput
                classes={'form-input big'}
                isSymbol={'input-symbol'}
                label={rata_mesile_label}
                labelStyle={{ fontSize: '0.9rem' }}
                placeholder={'Scrivi la Rata mensile'}
                theSymbol={'€'}
                type={'text'}
                update={this.props.inputOnChange}
              />
              <div className="guide-tips">
                <span className="guide-tips-label">Min €50 Max €1.500</span>
              </div>
            </li>
            <li className="wide buttons">
              <a
                className="btn btn-secondary"
                onClick={this.props.handleDoCustomCalc}
              >
                <span>Calcola la tua rata</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="calculator-container-right">{this.props.children}</div>
      </div>
    )
  }
}

BuyCustomCalc.propTypes = {
  selectOnChange: PropTypes.func.isRequired,
  handleDoCustomCalc: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  selectQuotaDaFinanziareClassName: PropTypes.string,
  liRataMensileClassName: PropTypes.string,
}

export default BuyCustomCalc
